'use strict';

var _ = require('lodash');
var d3 = require('d3');
var Scales = function Scales(params, data) {
  var x = d3.scale.ordinal().domain(_.map(data, 'xLabel')).rangeRoundBands([0, params.width], 0.18367347, 0.05);
  var circleRadius = Math.min(x.rangeBand() / 8, 10);
  var circleData = _.transform(data, function (result, element) {
    result.push.apply(result, _.map(element.circles, 'value'));
  }, []);
  var minCircleData = _.min(circleData);
  var yMin = d3.min(data, function (d) {
    return d.barValue;
  });
  yMin = yMin > 0 ? 0 : yMin;
  var maxCircleData = _.max(circleData);
  var yMax = d3.max(data, function (d) {
    return d.barValue;
  });
  yMax = yMax < 0 ? 0 : yMax;
  var yDomain;
  function getDelta(circleQuantity) {
    var range = maxCircleData - minCircleData;
    return ((params.height + circleRadius * circleQuantity) / params.height * range - range) / circleQuantity;
  }
  if (circleData.length === 0) {
    yDomain = [yMin, yMax];
  } else if (maxCircleData + getDelta(2) >= yMax && minCircleData - getDelta(2) <= yMin) {
    var halfRange = (maxCircleData - minCircleData) / 2;
    var center = maxCircleData - halfRange;
    var newHalfRange = (maxCircleData - minCircleData) / ((params.height - circleRadius * 2) / params.height) / 2;
    yDomain = [center - newHalfRange, center + newHalfRange];
  } else if (maxCircleData + getDelta(1) >= yMax) {
    yDomain = [yMin, yMin + (maxCircleData - yMin) / ((params.height - circleRadius) / params.height)];
  } else if (minCircleData - getDelta(1) <= yMin) {
    yDomain = [yMax - (yMax - minCircleData) / ((params.height - circleRadius) / params.height), yMax];
  } else {
    yDomain = [yMin, yMax];
  }
  var y = d3.scale.linear().domain(yDomain).rangeRound([params.height, 0]);
  return {
    xScale: x,
    yScale: y
  };
};
Scales.$inject = [];
module.exports = Scales;